import ReportCategory from '@/models/ReportCategory'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
    },
    reportCategoryDetails: null,
  },

  mutations: {
    setReportCategoryList(state, reportCategories) {
      each(reportCategories, (reportCategory) => {
        const exist = find(state.list, { id: reportCategory.id })
        if (!exist) {
          state.list.push(new ReportCategory(reportCategory))
        }
      })
    },

    clearReportCategoryList(state) {
      state.list = []
    },

    setReportCategoryListMeta(state, meta) {
      state.listMeta = meta
    },

    setReportCategoryDetails(state, reportCategory) {
      if (reportCategory instanceof ReportCategory) {
        state.reportCategoryDetails = reportCategory
      } else {
        state.reportCategoryDetails = new ReportCategory(reportCategory)
      }
    },

    clearReportCategoryDetails(state) {
      state.reportCategoryDetails = null
    },
  },

  actions: {
    async getReportCategories({ commit }, params) {
      const query = ReportCategory.page(params.page || 1).orderBy(params.sort)

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 20 }).get()
      commit('setReportCategoryList', res.data)
      commit('setReportCategoryListMeta', res.meta)
    },

    async getReportCategoryDetails({ commit }, id) {
      const { data } = await Api.get(`admin/report-categories/${id}`)
      commit('setReportCategoryDetails', data.data)
    },

    async createReportCategory({ commit }, formData) {
      const { data } = await Api.post(`admin/report-categories`, formData)
      commit('setReportCategoryDetails', data.data)
    },

    async updateReportCategory({ commit }, formData) {
      const { data } = await Api.put(
        `admin/report-categories/${formData.id}`,
        formData
      )
      commit('setReportCategoryDetails', data.data)
    },

    async deleteReportCategory({ commit }, id) {
      await Api.delete(`admin/report-categories/${id}`)
      commit('clearReportCategoryDetails', id)
    },

    async exportToExcel({ commit }, params) {
      let endpoint = params.search
        ? `admin/report-categories/export/${params.search}`
        : `admin/report-categories/export`
      const file = await Api.get(endpoint, {
        responseType: 'blob',
      })
      return file
    },
  },
}
